export const getTypePayment = (type: string) => {
    switch(type){
        case "deposit":
            return "Depósito de paçoquinhas"
        case "transfer_received":
            return "Paçoquinhas recebidas"
        case "ad_reward":
            return "Recompensa por anúncio"
        case "verified":
            return "Compra de Verificado"
        case "donate":
            return "Doação para o Paçoca"
        case "transfer_sent":
            return "Transferência de paçoquinhas enviada"
        default:
            return "Pagamento"
    }
}

export const isPositive = (type: string) => {
    if(type == "deposit" || type == "transfer_received" || type == "ad_reward") return true;
    if(type == "verified" || type == "donate" || type == "transfer_sent" || type == "buy_book") return false;
    return false;
}
